import { render, staticRenderFns } from "./match-selection.vue?vue&type=template&id=7660eb58&scoped=true"
import script from "./match-selection.vue?vue&type=script&lang=js"
export * from "./match-selection.vue?vue&type=script&lang=js"
import style0 from "./match-selection.vue?vue&type=style&index=0&id=7660eb58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7660eb58",
  null
  
)

export default component.exports